module.exports = __webpack_public_path__ + "static/media/M3DS Roll On (2oz) Mockup (Trans)ReducedSize-25percent.5e8ba703.svg";